module.exports = __webpack_public_path__ + "static/media/wildling.1dc6a718.png";